import React, { useEffect, useState } from "react";

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  if (t <= 0) return null;
  const d = Math.floor(t / 864e5);
  const h = Math.floor((t % 864e5) / 36e5);
  const m = Math.floor((t % 36e5) / 6e4);
  const s = Math.floor((t % 6e4) / 1e3);
  return { d, h, m, s };
}

export default function Countdown({ target, label }) {
  const [c, setC] = useState(() => (target ? diff(target) : null));
  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setC(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);
  if (!target || !c) return null;
  const cell = (v, l) => (
    <div className="flex flex-col items-center">
      <span className="text-3xl sm:text-4xl font-extrabold tabular-nums text-white">{String(v).padStart(2, "0")}</span>
      <span className="text-[10px] uppercase tracking-widest text-slate-300">{l}</span>
    </div>
  );
  return (
    <div data-testid="giveaway-countdown">
      {label && <p className="text-xs uppercase tracking-[0.2em] text-launch font-bold mb-3">{label}</p>}
      <div className="flex items-center gap-4 sm:gap-6">
        {cell(c.d, "Days")}<span className="text-2xl text-slate-500">:</span>
        {cell(c.h, "Hrs")}<span className="text-2xl text-slate-500">:</span>
        {cell(c.m, "Min")}<span className="text-2xl text-slate-500">:</span>
        {cell(c.s, "Sec")}
      </div>
    </div>
  );
}
